import AppleStoreLogo from "../assets/images/apple-store.svg";
import AssistantCallLogo from "../assets/images/assistant-call.svg";
import BreatherShopsLogo from "../assets/images/breather.png";
import CarPlaceholderLogo from "../assets/images/car-placeholder.svg";
import CarLogo from "../assets/images/car.png";
import HowToGetVinLogo from "../assets/images/car_vin.png";
import CloseLogo from "../assets/images/close.svg";
import DownArrowLogo from "../assets/images/downArrow.svg";
import DriverCardLogo from "../assets/images/driver-card.svg";
import DurationLogo from "../assets/images/duration.svg";
import ErrorInfoLogo from "../assets/images/error-info.svg";
import FleetCreationGif from "../assets/images/fleet-creation-animation.gif";
import FleetSuccessCarLogo from "../assets/images/fleet-success-car.png";
import FleetAdviseShortLogo from "../assets/images/fleetadvise-short.svg";
import FleetAdviseLogo from "../assets/images/fleetadvise.svg";
import FleetCoreLogo from "../assets/images/fleetcor.svg";
import FleetCoreShortLogo from "../assets/images/fleetcore-short.svg";
import GooglePlayLogo from "../assets/images/google-play.svg";
import GrayInfoLogo from "../assets/images/gray-info-logo.svg";
import InfoLogo from "../assets/images/info.svg";
import MobileHomeLogo from "../assets/images/mobile-home-bg.svg";
import MobileLogo from "../assets/images/mobile.svg";
import NotifyLogo from "../assets/images/notify.svg";
import PiggyLogo from "../assets/images/piggy.svg";
import QuestionLogo from "../assets/images/question-logo.svg";
import RightArrow from "../assets/images/right-arrow.svg";
import RoundedRightLogo from "../assets/images/rounde-right.svg";
import Section2IntroLogo from "../assets/images/section2-intro-png.png";
import SfoStep1Logo from "../assets/images/sfo-step1.svg";
import SfoStep2Conclusion from "../assets/images/sfo-stpe3-conclusion.svg";
import SfoStep2Logo from "../assets/images/step2-intro.svg";
import SfoStep3Logo from "../assets/images/step3-intro.svg";
import UpArrow from "../assets/images/up-arrow.svg";
import VerticalLineLogo from "../assets/images/vertical-line.svg";
import VehicleIcon from "../assets/images/vehicle_icon.svg";
import DriverDetailsIcon from "../assets/images/driver_details_icon.svg"
import GreenRight from "../assets/images/green-right.svg";

import { FLEETCOR, FLEET_ADVISE } from "./affiliations";

export const svgAndImagesRegistry = {
  [FLEETCOR]: FleetCoreLogo,
  [`${FLEETCOR}_short`]: FleetCoreShortLogo,
  [FLEET_ADVISE]: FleetAdviseLogo,
  [`${FLEET_ADVISE}_short`]: FleetAdviseShortLogo,
  sfoStep1: SfoStep1Logo,
  duration: DurationLogo,
  sfoStep2Intro: SfoStep2Logo,
  InfoLogo: InfoLogo,
  closeLogo: CloseLogo,
  breatherLogo: BreatherShopsLogo,
  assistantLogo: AssistantCallLogo,
  sfoStep3Intro: SfoStep3Logo,
  CarLogo: CarLogo,
  fleetCreationGif: FleetCreationGif,
  roundedRightLogo: RoundedRightLogo,
  piggyLogo: PiggyLogo,
  appleStoreLogo: AppleStoreLogo,
  googlePlayLogo: GooglePlayLogo,
  driverCardLogo: DriverCardLogo,
  fleetSuccessCarLogo: FleetSuccessCarLogo,
  mobileLogo: MobileLogo,
  notifyLogo: NotifyLogo,
  sfoStep2Conclusion: SfoStep2Conclusion,
  mobileHomeLogo: MobileHomeLogo,
  carPlaceholderLogo: CarPlaceholderLogo,
  howToGetVinLogo: HowToGetVinLogo,
  UpArrow: UpArrow,
  rightArrow: RightArrow,
  verticalLineLogo: VerticalLineLogo,
  questionLogo: QuestionLogo,
  DownArrow: DownArrowLogo,
  Section2IntroLogo: Section2IntroLogo,
  GrayInfoLogo: GrayInfoLogo,
  ErrorInfoLogo: ErrorInfoLogo,
  VehicleIcon : VehicleIcon,
  DriverDetailsIcon : DriverDetailsIcon,
  greenRight: GreenRight,
};

const imageRegistry = { ...svgAndImagesRegistry };

export default imageRegistry;
